var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('b-logo-v'),_c('transition',{attrs:{"name":"loading"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading__bd"},[_c('div',{staticClass:"loading__text",domProps:{"innerHTML":_vm._s(_vm.$t('loading-text'))}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }